import {ActionCreator, createAction} from '@packages/utilities/create-action';
import {
  FORM_EMAIL_TARGET_UPDATE_REQUESTED,
  FORM_SETTINGS_FETCH_REQUESTED,
  FORM_SETTINGS_UPDATE_REQUESTED,
  NOTIFICATION_ADDED,
} from '@packages/systems/designer/actions';
import type {FormSettingsPayload} from '@packages/systems/designer/forms/types';
import type {Notification} from '@packages/systems/core/records/NotificationRecord';

export const formEmailTargetUpdateRequested: ActionCreator<
  typeof FORM_EMAIL_TARGET_UPDATE_REQUESTED,
  {
    userEmails: string[];
    emailAction: string;
  }
> = createAction(FORM_EMAIL_TARGET_UPDATE_REQUESTED);

export const formSettingsFetchRequested: ActionCreator<
  typeof FORM_SETTINGS_FETCH_REQUESTED,
  {
    formId: string;
    componentId?: string;
    byElementId?: boolean;
  }
> = createAction(FORM_SETTINGS_FETCH_REQUESTED);

export const formSettingsUpdateRequested: ActionCreator<
  typeof FORM_SETTINGS_UPDATE_REQUESTED,
  {
    formId: string;
    componentId?: string;
    settings: FormSettingsPayload;
    byElementId?: boolean;
  }
> = createAction(FORM_SETTINGS_UPDATE_REQUESTED);

// Same contract as `notificationAdded` in @packages/systems/notifications/client.
// Defined here because that barrel pulls in Knock and Next.js, and the
// published-site renderer Lambdas bundle this package; importing it there
// pushed them past the 250MB Lambda limit.
export const formNotificationAdded: ActionCreator<
  typeof NOTIFICATION_ADDED,
  Notification
> = createAction(NOTIFICATION_ADDED);
